import React from 'react';
import { makeStyles, Grid } from '@material-ui/core';
import Avatar from '../Avatar';

export type DialogueBoxProps = {
  image: string;
  message: React.ReactNode;
};

const useStyles = makeStyles(() => ({
  left: {
    width: 40,
    marginRight: 16,
    display: 'inline-block',
  },
  right: {
    width: 'calc(100% - 56px)',
    display: 'inline-block',
  },
}));

const DialogueBox = ({ image, message }: DialogueBoxProps): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="flex-start" alignItems="center">
      <div className={classes.left}>
        <Avatar data-testid="avatar" size={40} image={image} />
      </div>
      <div data-testid="message-content" className={classes.right}>
        {message}
      </div>
    </Grid>
  );
};

export default DialogueBox;
